import { render, staticRenderFns } from "./EditResourceGroupModal.vue?vue&type=template&id=5a5ea22b&scoped=true&"
import script from "./EditResourceGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditResourceGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./EditResourceGroupModal.vue?vue&type=style&index=0&id=5a5ea22b&prod&lang=less&scoped=true&"
import style1 from "@/assets/less/manage-space/base.less?vue&type=style&index=1&id=5a5ea22b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ea22b",
  null
  
)

export default component.exports